import ReactDOM from 'react-dom';
// -*- mode: jsx;-*-

// Defined in general.js
/* global isNonBlankCookie isLoggedIn */

import { EmailContactSignUpWidget } from './emailContactSignUpWidget.js';


function setupEmailContactSignUpWidget () {
    if (document.getElementById('email-contact-sign-up-widget-in-body')) {
        renderEmailContactSignUpWidgetForEl('email-contact-sign-up-widget-in-body');
    } else if (document.getElementById('email-contact-sign-up-widget')) {
        renderEmailContactSignUpWidgetForEl('email-contact-sign-up-widget');
    }
}

function renderEmailContactSignUpWidgetForEl (elName) {
    if (document.getElementById(elName)) {
        ReactDOM.unmountComponentAtNode(document.getElementById(elName) );
    }

    // Only display this widget for non-signed in
    var userCookieExists = isNonBlankCookie('userId');
    if (userCookieExists || isLoggedIn()) {
        return;
    }

    ReactDOM.render(
        <EmailContactSignUpWidget />,
        document.getElementById(elName),
    );
}

$(document).ready(function () {
    setupEmailContactSignUpWidget();
});

$(window).on('signoutTriggered', function () {
    setupEmailContactSignUpWidget();
});

$(window).on('signinTriggered', function () {
    setupEmailContactSignUpWidget();
});
